module.exports = __webpack_public_path__ + "static/media/subtitle_ticket.4411ff4d.svg";